/* Shared, deterministic URLs: no cookie or localStorage product selection. */
(() => {
  const config = typeof document !== 'undefined' ? document.currentScript?.dataset : {};
  const previewThemeId = config?.previewThemeId || '165506744564';
  const siteProductPath = config?.singleSiteProduct || '';
  const singleSite = Boolean(siteProductPath);
  const validHandle = value => typeof value === 'string' && value.length <= 255 && /^[\p{L}\p{N}][\p{L}\p{N}-]*$/u.test(value);
  function catalogUrl(productPath, currentHref, catalogPath = '/collections/all') {
    const current = new URL(currentHref);
    const handle = decodeURIComponent(productPath.split('/').filter(Boolean).at(-1) || '');
    if (!validHandle(handle)) throw new Error('Invalid product');
    const url = new URL(catalogPath, current.origin);
    if (singleSite) return url.pathname;
    url.searchParams.set('view', 'campaign-lab');
    url.searchParams.set('item', handle);
    for (const key of ['preview_key', 'preview_theme_id']) {
      if (current.searchParams.get(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    url.searchParams.set('preview_theme_id', previewThemeId);
    return url.pathname + url.search;
  }
  function productUrl(productPath, currentHref, view = 'campaign-lab', variant = '') {
    const current = new URL(currentHref);
    const url = new URL(singleSite ? siteProductPath : productPath, current.origin);
    if (url.origin !== current.origin || !/\/products\/[^/]+$/.test(url.pathname)) throw new Error('Invalid product path');
    if (singleSite) {
      if (view !== 'campaign-lab') url.searchParams.set('view', view);
      if (variant) url.searchParams.set('variant', variant);
      return url.pathname + url.search;
    }
    if (current.searchParams.get('preview_key')) {
      url.pathname = url.pathname.replace(/\/products\/[^/]+$/, '/products_preview');
      url.searchParams.set('preview_key', current.searchParams.get('preview_key'));
    }
    url.searchParams.set('view', view);
    if (variant) url.searchParams.set('variant', variant);
    url.searchParams.set('preview_theme_id', previewThemeId);
    return url.pathname + url.search;
  }
  function canUseRenderedCatalog(handle, mode, currentHref) {
    const current = new URL(currentHref);
    const requested = current.searchParams.get('item');
    if (singleSite) return mode === '单品独立站' && decodeURIComponent(siteProductPath.split('/').at(-1)) === handle;
    // A draft preview key must still be checked against the product it resolves to.
    return mode === '单品独立站' && validHandle(handle) && !current.searchParams.has('preview_key') &&
      (requested === null || requested === handle);
  }
  function catalogSectionUrl(currentHref, catalogPath = '/collections/all') {
    const current = new URL(currentHref);
    const requested = current.searchParams.get('item');
    if (!validHandle(requested)) throw new Error('Invalid product');
    const prefix = catalogPath.replace(/\/collections\/all$/, '');
    const source = new URL(productUrl(`${prefix}/products/${encodeURIComponent(requested)}`, currentHref, 'campaign-lab-home'), current.origin);
    source.searchParams.set('section_id', 'campaign-lab-catalog');
    return source.href;
  }
  let pendingCatalog;
  function requestCatalog(currentHref, catalogPath, fresh = false) {
    const url = catalogSectionUrl(currentHref, catalogPath);
    if (!fresh && pendingCatalog?.url === url) return pendingCatalog.promise;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    const promise = fetch(url, {credentials: 'same-origin', signal: controller.signal})
      .then(response => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.text();
      })
      // The head can finish before the UI exists; retain failures for the retry UI.
      .then(html => ({html}), error => ({error}))
      .finally(() => clearTimeout(timer));
    pendingCatalog = {url, promise};
    return promise;
  }
  const api = Object.freeze({singleSite, validHandle, catalogUrl, productUrl, canUseRenderedCatalog, catalogSectionUrl, requestCatalog});
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') {
    window.CampaignRoutes = api;
    if (!singleSite && config?.campaignCatalogPath && !canUseRenderedCatalog(config.catalogHandle, config.catalogMode, location.href)) {
      try { requestCatalog(location.href, config.campaignCatalogPath); } catch { /* The UI handles invalid links. */ }
    }
    document.dispatchEvent(new Event('campaign:routes-ready'));
  }
})();
